module.exports = __webpack_public_path__ + "img/arrow-orange.f248177d.svg";